import { TableBody, TableHead, TableRow } from '@mui/material';
import { useMemo, useState } from 'react';
import { useScreenClass } from 'react-grid-system';
import styled from 'styled-components';
import theme from '../styles/theme';
import FlexBox, { FlexGrow } from './FlexBox';
import { ClickableIcon } from './Icon';
import Modal from './Modal';
import TableComponent, { StyledBodyCell, StyledHeaderCell, StyledTableRow } from './Table';

const Header = styled.h4`
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: left;
`;
const CustomFlex = styled(FlexBox)`
  padding: 20px 0;
  align-items: center;
  border-bottom: 1px solid #3c406c;
`;
const topicData = [
  {
    name: 'Knowledge topic name',
    description: 'Bla jsdkdjvskdvskdvjb',
    id: '1',
  },
  {
    name: 'Knowledge topic name',
    description: 'Bla jsdkdjvskdvskdvjb',
    id: '2',
  },
  {
    name: 'Knowledge topic name',
    description: 'Bla jsdkdjvskdvskdvjb',
    id: '3',
  },
  {
    name: 'Knowledge topic name',
    description: 'Bla jsdkdjvskdvskdvjb',
    id: '4',
  },
  {
    name: 'Knowledge topic name',
    description: 'Bla jsdkdjvskdvskdvjb',
    id: '5',
  },
  {
    name: 'Knowledge topic name',
    description: 'Bla jsdkdjvskdvskdvjb',
    id: '6',
  },
];
interface Column {
  id: 'name' | 'description';
  label: string;
  minWidth?: number;
  align?: 'right';
  format?: (value: number) => string;
}
type ModifySkillModalProps = {
  isOpen?: boolean;
  setOpen: (x: boolean) => void;
  onTopicSelected: (x: any) => void;
};
const TopicListModal = ({
  isOpen,
  setOpen,
  onTopicSelected,
}: ModifySkillModalProps): JSX.Element => {
  const screenClass = useScreenClass();
  const isMobile = useMemo(
    () => ['xs', 'sm'].includes(screenClass),
    [screenClass],
  );
  const [columns, setColumns] = useState<Array<Column>>([
    { id: 'name', label: 'Knowledge Topic Title', minWidth: 150 },
    { id: 'description', label: 'Description', minWidth: 200 },
  ]);
  const optionsSkill = [
    { label: 'Test', value: 'Test' },
    { label: 'Test2', value: 'Test1' },
  ];
  return (
    <>
      <Modal
        isOpen={isOpen || false}
        setOpen={setOpen}
        customStyle={{
          overlay: {
            zIndex: '999968',
          },
          content: {
            maxWidth: '500px',
            padding: '0 24px',
            color: 'black',
            background: '#FFFFFF',
            border: '1px solid #E7EBEE',
            boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.07)',
            borderRadius: '8px',
          },
        }}>
        <CustomFlex>
          <FlexGrow>
            <Header>Choose Knowledge Topic</Header>
          </FlexGrow>
          <ClickableIcon
            size={3.125}
            fixedWidth={false}
            color="black"
            name="close"
            onClick={() => setOpen(false)}
          />
        </CustomFlex>
        <CustomFlex
          style={{
            borderBottom: 'none',
            alignItems: 'flex-start',
            overflowY: 'scroll',
          }}>
          <FlexGrow>
            <TableComponent autoHeight navHeight="0" aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <StyledHeaderCell
                      key={column.id}
                      align={column.align}
                      backgroundColor={theme.color.lightBlueGray50}
                      color={theme.color.lightBlueGray800}
                      style={{ minWidth: column.minWidth }}>
                      {column.label}
                    </StyledHeaderCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {topicData.map((row: any, index) => {
                  return (
                    <StyledTableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      onClick={() => {
                        onTopicSelected(row);
                      }}
                      key={index}>
                      {columns.map((column) => {
                        const value = row[column.id];
                        return (
                          <StyledBodyCell key={column.id} align={column.align}>
                            {column.format && typeof value === 'number'
                              ? column.format(value)
                              : value}
                          </StyledBodyCell>
                        );
                      })}
                    </StyledTableRow>
                  );
                })}
              </TableBody>
            </TableComponent>
          </FlexGrow>
        </CustomFlex>
      </Modal>
    </>
  );
};

export default TopicListModal;
